import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center p-8 m-5 bg-white rounded-lg shadow-md max-w-lg mx-auto text-center">
          <h2 className="text-xl font-bold text-red-600 mb-3">
            Something went wrong
          </h2>
          <p className="text-gray-600 text-sm mb-5">
            An unexpected error occurred while loading this section. Please try refreshing or going back.
          </p>
          <button
            className="px-4 py-2 bg-sky-500 text-white rounded shadow hover:bg-sky-600 transition-colors"
            onClick={() => {
              this.setState({ hasError: false, error: null });
              if (this.props.onReset) {
                this.props.onReset();
              } else {
                window.location.reload();
              }
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
